module.exports = __webpack_public_path__ + "img/nicolobellarmino.29b287a3.jpg";